import {
  PublicGetFundingRateHistoryParamsSchema,
  PublicGetFundingRateHistoryResponseSchema,
} from '../api/types/public.get_funding_rate_history'
import tryRequest from './tryRequest'

export default async function fetchFundingRateHistory(
  params: PublicGetFundingRateHistoryParamsSchema
): Promise<PublicGetFundingRateHistoryResponseSchema> {
  return tryRequest<
    PublicGetFundingRateHistoryParamsSchema,
    PublicGetFundingRateHistoryResponseSchema
  >('/public/get_funding_rate_history', params, { useGet: true })
}
